import {useEffect, useState} from "react";
import {useTranslation, withTranslation} from "react-i18next";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";
import {useLocation} from "react-router-dom";
import {xcService} from "_services/xcService";
import endpoint from "shared/endpoints";

function ResponsesCeiba(props) {
    const {t} = useTranslation();
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const {search} = useLocation();

    const [answers, setAnswers] = useState([]);
    const userType = storage.getItem(variables.USER_TYPE);
    const studentUid = new URLSearchParams(search).get('user');

    useEffect(() => {
        const answersPath = userType === 'STUDENT' ? endpoint.studentAnswer.getAll('CEIBA') : `/v1/student/${studentUid}/answers/CEIBA`;
        xcService.getToken(answersPath).then(({data}) => setAnswers(data.data));

    }, [userType]);


    return (
        <div className={"container dasboard-informes"}>
            <div className={"container-question container-question__end centerResponses"}>
                <div className={"container-question__auto-margin"}>
                    <div className={"question__header"}>
                        <img className={"question__header-icon"} src={`/assets/img/report.png`}/>
                        <h2>{t("tek.endtitleS")}</h2>
                    </div>
                    <div className={"question__content"}>
                        <div className={"question__content-list"}>
                            {answers.map(item => (
                                <div className={"list-item"}>
                                    <div className={"list-item-l"}>

                                        <div style={{display: "flex", alignItems: "center"}}>
                                            <img className={"list-item__icon"}
                                                 src={`/assets/img/${item.assessment.area.image}`}/>
                                            <div
                                                className={`list-item__text `}>
                                                <div style={{
                                                    display: "flex",
                                                    lineHeight: "17px"
                                                }}>{item.assessment.area.name}
                                                    <div style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        marginLeft: "4px",
                                                        cursor: "pointer"
                                                    }}></div>
                                                </div>
                                            </div>
                                        </div>
                                        <>
                                            {item.points !== 999 ?
                                                <div className={"content-bar"}>
                                                    <div style={{
                                                        borderRadius: 18,
                                                        width: `${(10 * item.points)}%`
                                                    }}
                                                         className={`list-item__points ${item.points > 0 && item.points < 5 ? "list-item__points--red" :
                                                             item.points >= 5 && item.points < 8 ? "list-item__points--yellow" : item.points === 999 ? "" : "list-item__points--green"
                                                         }`}>
                                                        {item.points !== 999 ? item.points : t('indeciso')}
                                                        <span>{item.points !== 999 && t("ceiba.puntos")}</span>
                                                    </div>
                                                </div>
                                                :
                                                <p className={"list-item__points list-item__points--idk"}
                                                   style={{color: "#8C8C8C"}}>{t("indeciso")}</p>
                                            }
                                        </>
                                    </div>

                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default withTranslation()(ResponsesCeiba);


